import { MethodCardContent } from '@/core/components/Card/components/MethodCardContent'
import { CallableTitleWithGraftabilityHint } from '@/core/hooks/useCardNavigation/components/CallableTitleWithGraftabilityHint/CallableTitleWithGraftabilityHint'
import { createNavigationCardItem } from '@/core/hooks/useCardNavigation/utils/createNavigationCardItem'
import { getBadgeLabel } from '@/core/hooks/useCardNavigation/utils/getBadgeLabel'
import { getParameterNamesSummary } from '@/core/hooks/useCardNavigation/utils/getParameterNamesSummary'
import type { ClassData, LibraryData, MethodData } from '@/core/types/library.type'
import { analyzeMethodGraftability, buildHostedTypeFqns, buildHostingLibraryContext } from '@/core/utils/graftability'

interface BuildMethodEntriesParams {
  classData: ClassData
  library: LibraryData
  openAccordions: string[]
  onAccordionToggle: (itemId: string) => void
}

export const buildMethodEntries = ({
  classData,
  library,
  openAccordions,
  onAccordionToggle,
}: BuildMethodEntriesParams) => {
  const analysisOptions = {
    hostedTypeFqns: buildHostedTypeFqns(library),
    hostingLibraryContext: buildHostingLibraryContext(library),
  }

  return classData.methods
    ? Object.entries(classData.methods).map(([methodKey, method]: [string, MethodData]) => {
        const badge = getBadgeLabel(method.type)
        const graftabilityIssues = analyzeMethodGraftability(method, classData, analysisOptions)
        const title = (
          <CallableTitleWithGraftabilityHint
            name={method.name}
            parameters={method.parameters}
            issues={graftabilityIssues}
          />
        )

        const content = (
          <MethodCardContent
            method={method}
            methodKey={methodKey}
            classData={classData}
            runtimeName={library.runtimeName}
          />
        )

        return createNavigationCardItem({
          id: methodKey,
          title,
          name: method.name,
          badge,
          description: getParameterNamesSummary(method.parameters),
          content,
          isOpen: openAccordions.includes(methodKey),
          onAccordionToggle,
          graftabilityIssues,
        })
      })
    : []
}
